<div class="container-fluid" [ngClass]="!theme ? 'dark-theme' : ''">
    <div class="row">
        <div class="col-sm-12 p-0">
            <div class="card mb-0 border-0">
                <div class="card-body p-0">
                    <div class="profile-bg  position-relative">
                        <div class="bg-overlay p-48">
                            <h1 class="txt-blue txt-heading mb-2">Teams</h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-4 team-wrapper">
            <div class="card team-card">
                <div class="card-body">
                    <h1 class="txt-black">Create Team</h1>
                    <input type="text" class="form-control input mb-3" [(ngModel)]="teamName" placeholder="Team Name">
                    <button class="btn btn-primary float-right" (click)="createTeam()">Add Team</button>
                </div>
            </div>
        </div>
        <div class="col-sm-8 mt-4">
            <div class="mb-4" *ngFor="let team of teams">
                <mat-accordion class="box-shadow-none" multi>
                    <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false" >
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <span class="fs-16 fw-600">{{team.name}}</span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="team-content">
                            <div class="d-flex justify-content-end align-items-center mb-3 me-3">
                                <button class="btn btn-primary btn-sm" (click)="openAddUserModel(team.tid)">Add User</button>
                                <i class="bi bi-trash txt-red ms-3"  role="button" (click)="deleteFullTeam(team.tid)"></i>
                            </div>
                            <table class="align-top team-tabel w-100">
                                <thead>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Audit/Editor</th>
                                    <th>Keyword Report</th>
                                    <th>SERP</th>
                                    <th>Actions</th>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let key of objectKeys(team.credits);let i= index">
                                        <td class="Neutral dark-content text-truncate">{{team.credits[key].first_name}} {{team.credits[key].last_name}}</td>
                                        <td class="Neutral dark-content text-truncate">{{team.credits[key].email}}</td>
                                        <td class="Neutral dark-content text-truncate">{{team.credits[key].credits}}</td>
                                        <td class="Neutral dark-content text-truncate">{{team.credits[key].kwCred}}</td>
                                        <td class="Neutral dark-content text-truncate">{{team.credits[key].serpCred}}</td>
                                        <td><i class="bi bi-trash txt-red" role="button" (click)="removeUser(team.credits[key].uid,team.tid)"></i></td>
                                    </tr>
    
                                    <!-- <tr>
                                        <td class="Neutral dark-content text-truncate">Team</td>
                                        <td class="Neutral dark-content text-truncate">2</td>
                                        <td class="Neutral dark-content text-truncate">5</td>
                                        <td class="Neutral dark-content text-truncate">200</td>
                                        <td><i class="bi bi-trash txt-red" role="button"></i></td>
                                    </tr> -->
                                </tbody>
                            </table>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>

            <!-- <div class="mb-4">
                <mat-accordion class="box-shadow-none" multi>
                    <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false" >
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <i class="bi bi-trash txt-red"></i>
                                <span class="fs-16 ps-3 fw-600">Team Name</span>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="team-content">
                            <div class="d-flex justify-content-end align-items-center mb-3">
                                <button class="btn btn-primary me-3 btn-sm" (click)="openAddUserModel()">Add User</button>
                            </div>
                            <table class="align-top team-tabel w-100">
                                <thead>
                                    <th>Name</th>
                                    <th>Audit/Editor</th>
                                    <th>Keyword Report</th>
                                    <th>SERP</th>
                                    <th>Actions</th>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="Neutral dark-content text-truncate">A D</td>
                                        <td class="Neutral dark-content text-truncate">50</td>
                                        <td class="Neutral dark-content text-truncate">50</td>
                                        <td class="Neutral dark-content text-truncate">1000</td>
                                        <td><i class="bi bi-trash txt-red" role="button"></i></td>
                                    </tr>
    
                                    <tr>
                                        <td class="Neutral dark-content text-truncate">Team</td>
                                        <td class="Neutral dark-content text-truncate">2</td>
                                        <td class="Neutral dark-content text-truncate">5</td>
                                        <td class="Neutral dark-content text-truncate">200</td>
                                        <td><i class="bi bi-trash txt-red" role="button"></i></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>
            </div> -->
           
        </div>
       
    </div>
</div>